export default __webpack_public_path__ + "static/media/liucheng.d0758195.png";